// extracted by mini-css-extract-plugin
export default {"calendarWrapper":"styles_calendarWrapper__hlGh9"};